module.exports = __webpack_public_path__ + "img/logo.f912a9a7.svg";